import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

@Component({
	standalone: true,
	imports: [CommonModule],
	selector: 'cpi-square-post-loading-effect',
	templateUrl: './square-post-loading-effect.component.html',
	styleUrl: './square-post-loading-effect.component.scss',
})
export class SquarePostLoadingEffectComponent implements AfterViewInit, OnDestroy {
	@ViewChild('loadingTagCol') private loadingTagCol?: ElementRef<HTMLElement>;
	private resizeObserver?: ResizeObserver;

	@Input() barThickness = '2.25rem';
	@Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
	@Input() animationSpeed = '250ms';

	calculatedQuantity = 0;
	variancias: string[] = [];

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.updateQuantity();

			if (typeof ResizeObserver !== 'undefined' && this.loadingTagCol) {
				this.resizeObserver = new ResizeObserver(() => this.updateQuantity());
				this.resizeObserver.observe(this.loadingTagCol.nativeElement);
			}
		}, 0);
	}

	ngOnDestroy(): void {
		this.resizeObserver?.disconnect();
	}

	private updateQuantity(): void {
		const element = this.loadingTagCol?.nativeElement;
		if (!element) return;

		const availableSize = this.orientation === 'horizontal' ? element.clientHeight : element.clientWidth;
		const barSize = this.parseSize(this.barThickness);
		const gap = 8;

		if (availableSize <= 0 || barSize <= 0) return;

		this.calculatedQuantity = Math.max(1, Math.floor((availableSize + gap) / (barSize + gap)));
		this.variancias = Array.from(
			{ length: this.calculatedQuantity },
			// eslint-disable-next-line sonarjs/pseudo-random
			(_, index) => this.variancias[index] ?? `${Math.round(10 + Math.random() * 90)}%`
		);
	}

	private parseSize(size: string): number {
		const parsedSize = Number.parseFloat(size);
		if (size.endsWith('rem')) {
			return parsedSize * Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
		}

		return parsedSize;
	}
}
